import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";

export function B10({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.BSXY001.error_id: {
            return (
                <>
                    <ResultText>
                        Bank stations don't contain the stream centerline at the following {row?.data?.length} cross sections:
                    </ResultText>
                    <ResultText>
                        <CheckCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Internal.BSXY14.error_id: {
            return (
                <>
                    {
                        row?.data?.map(r => (
                            <ResultText>
                                Cross section cutline does not intersect with the stream centerline at RS {<CheckCSName csName={r.cross_section} />}. In order to calculate the intersection point, the stream centerline is extended.
                            </ResultText>
                        ))
                    }
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}